module.exports = __webpack_public_path__ + "static/self-esteem-cd8b1c4bfab4eddc9ef2394964bcc545.png";